import React from 'react';
import { Router, Route, Link, hashHistory } from 'react-router';

import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

const KeySheet = React.createClass({
	getInitialState: function() {
		return {
			quiz: JSON.parse(JSON.stringify(this.props.quiz))
		}
	},
	_saveKey: function() {
		let updatedQuiz = this.state.quiz;
		let request = new XMLHttpRequest();
		request.open('PUT', '/api/v2/quizzes/' + this.props.id);
		request.setRequestHeader('Content-Type', 'application/json');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(JSON.stringify(updatedQuiz));
		request.onreadystatechange = function() {
			if (request.status == 200 && request.readyState == 4) {
				this.props.getResults(this.props.id);
				this.props.defaultScoreSheet(localStorage.getItem('username'));
				this.props.updateView(0);
				this.props.updateQuestions(this.state.quiz.questions);
			}
		}.bind(this);
	},
	_updateAnswers: function(i, e) {
		let quiz = this.state.quiz;
		quiz.questions[i]['answer'] = e.target.value;
		this.setState({
			quiz: quiz
		});
	},
	_updateStatus: function(e, i, val) {
		let quiz = this.state.quiz;
		quiz.status = val;
		this.setState({
			quiz: quiz
		});
	},
	_displayQuestions: function() {
		return this.state.quiz.questions.map((question, i) => {
			if (question.choices.length) {
				const choices = question.choices.map((choice, j) => {
					return (
						<RadioButton
							key={j}
							value={choice}
							label={choice}
							onClick={this._updateAnswers.bind(this, i)}
						/>
					)
				});
				return (
					<div className="row" key={question._id}>
						<span className="index">{i+1}</span>
						<div className="question">
							<div className="body">{question.question}</div>
							<RadioButtonGroup
								name="answer"
								className="answer"
								valueSelected={question.answer}
							>
								{choices}
							</RadioButtonGroup>
						</div>
					</div>
				)
			} else {
				return (
					<div className="row" key={question._id}>
						<span className="index">{i+1}</span>
						<div className="question">
							<div className="body">{question.question}</div>
							<div className="answer">
								<TextField
									name={'question' + i}
									onChange={this._updateAnswers.bind(this, i)}
									value={question.answer}
								/>
							</div>
						</div>
					</div>
				)
			}
		})
	},
	_displayChoices: function() {
		return this.props.quiz.questions
	},
	render: function() {
		const questions = this._displayQuestions();
		const style={
			button: {
				color: '#fff',
				margin: '.618em 2.4em',
			},
		}
		return (
			<div className="key-sheet">
				<div className="status">
					<SelectField
						floatingLabelText="Quiz Status"
						value={this.state.quiz.status}
						onChange={this._updateStatus}
					>
						<MenuItem value="open" primaryText="Open" />
						<MenuItem value="in_progress" primaryText="In Progress" />
						<MenuItem value="closed" primaryText="Closed" />
					</SelectField>
				</div>
				<div className="questions">
					{questions}
				</div>
				<FlatButton
					label="Save"
					onClick={this._saveKey}
					backgroundColor="#82CCC8"
					hoverColor="#7CCEC7"
					style={style.button}
				/>
			</div>
		)
	}
});

export default KeySheet;


// WEBPACK FOOTER //
// ./src/views/key.jsx